// import moment from 'moment';
import moment from 'moment-timezone';

export const editGeofenceFormatData = (data) => {
  const result = [];

  data?.forEach((item) => {
    result?.push({ value: item?.propertyName, label: item?.id });
  });

  return result;
};

export const transformKeys = (arr) => {
  if (arr) {
    const result = [];

    arr?.forEach((item) => {
      result?.push({ lng: item?.longitude, lat: item?.latitude });
    });

    return result;
  }
};

export const convertTo12HourUTCFormatTime = (utcTime) => {
  return moment(utcTime).utcOffset('+05:30').format('h:mm:ss A');
};

export const convertToUserTimeZone = (utcTime, userTimeZone) => {
  return moment(utcTime).tz(userTimeZone).format('h:mm:ss A');
};

export const convertToUserTimeZoneDateTime = (utcTime, userTimeZone) => {
  return moment(utcTime).tz(userTimeZone).format('DD-MM-YYYY h:mm A');
};
